
import { defineComponent } from 'vue';
import Error from './Error.vue';

export default defineComponent({
  components: {
    Error,
  },
});
